import React, { useMemo } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { useSelector } from 'react-redux'
import AppFooterMobile from 'src/components/AppFooterMobile'
import { MENU_MOBILE_LAYOUT } from 'src/constants/PermissionConstants'
import { AppContent, AppFooter, AppHeader, AppSidebar } from '../components/index'
import { AuthContext } from '../context/AuthContext'

const DefaultLayout = () => {
  const auth = useSelector((state) => state.auth)

  const isShowMobile = useMemo(
    () => auth.permissions?.find((permission) => permission?.name?.includes(MENU_MOBILE_LAYOUT)),
    [auth],
  )

  const authParams = {
    auth,
    isShowMobile,
  }

  return (
    <AuthContext.Provider value={authParams}>
      {!!isShowMobile ? (
        <>
          <BrowserView>
            <AppSidebar />
            <div className="wrapper d-flex flex-column mx-0 min-vh-100 bg-light dark:bg-transparent">
              <AppHeader />
              <div className="body flex-grow-1 px-0 px-md-4">
                <AppContent />
              </div>
              <AppFooter />
            </div>
          </BrowserView>
          <MobileView>
            <div className="wrapper d-flex flex-column mx-0 min-vh-100 bg-light dark:bg-transparent">
              <AppHeader />
              <div className="body flex-grow-1 px-0 px-md-4">
                <AppContent />
              </div>
              <AppFooterMobile />
            </div>
          </MobileView>
        </>
      ) : (
        <>
          <AppSidebar />
          <div className="wrapper d-flex flex-column mx-0 min-vh-100 bg-light dark:bg-transparent">
            <AppHeader />
            <div className="body flex-grow-1 px-0 px-md-4">
              <AppContent />
            </div>
            <AppFooter />
          </div>
        </>
      )}
    </AuthContext.Provider>
  )
}

export default DefaultLayout
